import styled from "styled-components";
import { getTheme, themed, Box, Grid, ThemePalette, ColorDeclaration, } from "@bracket/ui";
import {
	Tooltip,
	Typography, 
	Text as Tx
} from "@bracket/ui";

import {
	Divider,
} from "@components";

import type {
	ReactNode,
	FunctionComponent,
} from "react";



export declare type PlatformCardItemProps = {
	label: string;
	value: string|ReactNode;
	tooltip: string;
	highlight?: "green" | "yellow";
	bold?: boolean;
	color?: keyof ThemePalette | ColorDeclaration;
};




export const PlatformCardItem: FunctionComponent<PlatformCardItemProps> = ({
	label,
	tooltip,
	value,
	highlight,
	bold,
	color,
}) => {
	themed();

	return (
		<div>
			<ItemContainer>
				<TitleContainer>
					<Tx lg bold={bold} color={color ?? "surface_on"}>{label}</Tx>
					<Tooltip message={tooltip} />
				</TitleContainer>

				<Tx lg color={color} bold={bold}>
					{value}
				</Tx>
			</ItemContainer>

			<Divider />
		</div>
	);
};


const ItemContainer = styled(Grid)`
	display: grid;
	grid-template-columns: 1fr 1fr;
	padding: 16px;
	gap: 12px;
	align-items: center;
`;

const TitleContainer = styled(Box)`
	display: flex;
	gap: 4px;
	align-items: center;
`;

const ValueText = styled(Typography)<{ $highlight?: "green" | "yellow"; $color?: string }>`
	color: ${(props) => {
		if (props.$color) return props.$color;
		if (props.$highlight === "green") return getTheme().primary;
		if (props.$highlight === "yellow") return getTheme().warning;
		return getTheme().paragraph;
	}};
`;
